/**
 * Business information.
 */
export interface BusinessInfo {
  readonly businessName: string
  /**
   * Date of incorporation, in the local time zone.
   */
  readonly dateOfIncorporation: Date | null
  readonly employerIdentificationNumber: string
}

export const BusinessInfo = {
  /**
   * Empty business info.
   */
  empty: {
    businessName: '',
    dateOfIncorporation: null,
    employerIdentificationNumber: '',
  } satisfies BusinessInfo,
}
